import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueI18n from 'vue-i18n'
import i18n from './common/i18n/i18n.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import LoadScript from 'vue-plugin-load-script'
import VueClipboard from 'vue-clipboard2'
import MetaInfo from 'vue-meta-info'

import 'ant-design-vue/dist/antd.css'
import '@/assets/css/global.css'
import '@/plugins/antd.js'
import Cookies from 'js-cookie'
// 引入字体图标
import '@fortawesome/fontawesome-free/css/all.css'

// 图片点击放大
import VueViewer from 'v-viewer'
// 导入 bus
import Bus from '@/common/bus'
/* 自定义指令 */
import directive from './directive'
/* 自定义v-fixed */
Vue.use(directive)

Vue.use(VueI18n).use(BootstrapVue).use(VueAxios, axios).use(VueClipboard)

Vue.use(LoadScript)

Vue.use(MetaInfo)
// 图片点击放大
Vue.use(VueViewer)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$Cookies = Cookies
Vue.prototype.$fontSizeList = ['14px', '16px', '18px']
Vue.prototype.$themeColorList = ['default', 'night', 'black']
Vue.prototype.$emailRegExp = '^[A-Za-z0-9_-\\u4e00-\\u9fa5]+(\\.[A-Za-z0-9_-\\u4e00-\\u9fa5]+)*@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$'
Vue.prototype.$phoneRegExp = /^[+]?[(]?[0-9]*[)]?[-\s]?[0-9]+$/
Vue.prototype.$cdtType = process.env.VUE_APP_CDT_TYPE
Vue.prototype.$isCn = window.location.hostname.endsWith('.hk')
// 在所有 .hk 的环境下将link的域名替换成 xxx.hk
Vue.prototype.$replaceHKLink = (urlStr) => {
  // 不是 .hk 环境下返回原本的 link
  if (!Vue.prototype.$isCn) {
    return urlStr
  }
  const citylineHostName = '.cityline.com'
  try {
    const url = new URL(urlStr)
    // 说明是 cityline 的域名,需要替换成 .hk结尾的
    if (url.hostname.includes(citylineHostName) && !url.hostname.endsWith('.hk')) {
      const resultUrl = url.href.replaceAll(url.hostname, url.hostname + '.hk')
      // 如果进来的url结尾没有 '/' 但是最后输出的时候携带了 '/'，那就将 '/' 去掉
      return (!urlStr.endsWith('/') && resultUrl.endsWith('/')) ? resultUrl.slice(0, -1) : resultUrl
    } else {
      return urlStr
    }
  } catch (error) {
    // 路径有问题，返回原本的 link
    // console.error('替换路径失败:', error)
    return urlStr
  }
}
// 在所有 .hk 的环境下将 富文本中a标签 img标签 video标签下的link替换成 .hk
Vue.prototype.$replaceRichTextHKLink = (urlStr) => {
  // 不是 .hk 环境下返回原本的 link
  if (!Vue.prototype.$isCn) {
    return urlStr
  }
  try {
    let result = ''
    result = urlStr.replaceAll(/(\.cityline\.com)(?!\.hk)([.]*)/g, (match, p1, p2) => {
      // 将 `.cityline.com` 替换为 `.cityline.com.hk`
      return match.replace(p1, p1 + '.hk')
    })
    return result
  } catch (error) {
    // 路径有问题，返回原本的 link
    // console.error('替换路径失败:', error)
    return urlStr
  }
}
Vue.prototype.$CookieDomain = Vue.prototype.$isCn ? '.cityline.com.hk' : '.cityline.com'
Vue.prototype.$showsLink = Vue.prototype.$replaceHKLink(process.env.VUE_APP_SHOWS_LINK)
Vue.prototype.$sportsLink = Vue.prototype.$replaceHKLink(process.env.VUE_APP_SPORTS_LINK)
Vue.prototype.$culturalLink = Vue.prototype.$replaceHKLink(process.env.VUE_APP_CULTURAL_LINK)
Vue.prototype.$priorityLink = Vue.prototype.$replaceHKLink(process.env.VUE_APP_PRIORITY_LINK)
Vue.prototype.$othersLink = Vue.prototype.$replaceHKLink(process.env.VUE_APP_OTHERS_LINK)
Vue.prototype.$cwApiBaseUrl = Vue.prototype.$replaceHKLink(process.env.VUE_APP_CW_API_BASE_URL)
Vue.prototype.$cwLink = Vue.prototype.$replaceHKLink(process.env.VUE_APP_CW_URL)
Vue.prototype.$tdmLink = Vue.prototype.$cwLink + '/TicketingTerminal.html'
/* 千分位加逗号 */
Vue.prototype.$amountRule = (amount) => {
  if (!amount) return 0
  const str = amount.toString()
  const regexp = str.includes('.') ? /(\d)(?=(\d{2})+\.)/g : /(\d)(?=(?:\d{2})+$)/g
  return str.replace(regexp, '$1,')
}

Vue.prototype.$getLikeNumber = (number) => {
  if (number >= 1000) {
    const kNumber = number / 1000
    if (kNumber >= 1000) {
      const MNumber = kNumber / 1000
      if (MNumber >= 10) {
        return `${parseInt(MNumber)}M`
      } else {
        return `${Math.floor(MNumber * 10) / 10}M`
      }
    } else {
      if (kNumber >= 10) {
        return `${parseInt(kNumber)}K`
      } else {
        return `${Math.floor(kNumber * 10) / 10}K`
      }
    }
  } else {
    return number
  }
}
Vue.prototype.$bus = Bus
const vm = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// const userAgent = navigator.userAgent
// if (!(userAgent.includes('compatible') && userAgent.includes('MSIE'))
//   && !(userAgent.includes('Trident') && userAgent.includes('rv:11.0'))) {
// AI Bot
// 請放在html尾或document ready內, 否則可能會error
// 需要re init時, 可以call以下functinon
// italk_chat_button.reinit()

// 其會在載入時, 及離開時插入兩個listener以ajax方法發送資料到server
if (process.env.VUE_APP_AI_SCRIPT_URL) {
  Vue.loadScript(process.env.VUE_APP_AI_SCRIPT_URL)
    .then(() => {
      // Script is loaded, do something
      const charImgDom = document.querySelector('#btn_chat > img')
      charImgDom.alt = vm.$t('describe.chat_p')
      if (charImgDom.style.marginLeft) {
        charImgDom.style.marginLeft = '-50px'
      }
      document.querySelector('#btn_chat').onclick = () => {
        vm.$bus.$emit('bus-clickHideNavbar')
      }
    })
    .catch(() => {
      // Failed to fetch script
    })
}
if (process.env.VUE_APP_AI_SCRIPT_URL2) {
  Vue.loadScript(process.env.VUE_APP_AI_SCRIPT_URL2)
    .then(() => {
      // Script is loaded, do something
    })
    .catch(() => {
      // Failed to fetch script
    })
}
